import { User } from "./User";
import { Client } from "./Client";

export class BirthdayList {
    constructor({
                    id= null,
                    company_id= null,
                    category_id= null,
                    name= '',
                    active= 1,
                    opportunities_active= 1,
                    template_id= null,
                    pipe_id= null,
                    created_at= new Date(),
                    updated_at= new Date(),
                    deleted_at= null,
                    users= [],
                    clients= [],
                    times_fired= null,
                    selection_type= 'all',
                    filters= [],
                    out_filters= []
                } = {}) {
        this.id = id;
        this.company_id = company_id;
        this.category_id = category_id;
        this.name = name;
        this.active = active;
        this.opportunities_active = opportunities_active;
        this.template_id = template_id;
        this.pipe_id = pipe_id;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.deleted_at = deleted_at;
        this.users = (users||[]).map(u=>new User(u));
        this.user_ids = (users||[]).map(u=>u.id);
        this.clients = (clients||[]).map(c=>new Client(c));
        this.times_fired = times_fired;
        this.selection_type = selection_type;
        this.filters = filters;
        this.out_filters= out_filters;
    }
}

export function createBirthdayList(data={}) {
    return Object.freeze(new BirthdayList(data));
}